<template>
	<div class="table_box" v-if="isShow">
		<div class="no_list" v-if="allisTurnIng && isMerge" :style="{
			height: allisTurnIng && !allZhError && isMerge ? '100%' : '323px'
		}">
			<div class="turn_box">
				<img v-if="pageType == 'ofdtopdf'" src="@comm/images/document-conversion/home/turn_icon_ofd.png" alt
					style="margin: 0" />
				<img v-else src="@comm/images/document-conversion/home/turn_athere.svg" alt style="margin: 0" />
				<div id="loading1">
					<div class="demo1"></div>
					<div class="demo1"></div>
					<div class="demo1"></div>
				</div>
				<img v-if="pageType == 'toofd'" src="@comm/images/document-conversion/home/turn_icon_ofd.png" alt
					style="margin: 0" />
				<img v-else src="@comm/images/document-conversion/upload_pdf.svg" alt style="margin: 0" />
			</div>
			<div class="turn_ing">文件转换中</div>
		</div>
		<div class="no_list" v-if="allZhError && !allisTurnIng && isMerge">
			<div class="fail_box">
				<img v-if="pageType == 'toofd'" src="@comm/images/document-conversion/ofd_pl.svg" alt
					style="margin: 0" />
				<img v-else src="@comm/images/document-conversion/pdf_pl.svg" alt style="margin: 0" />
				<a :title="folderName + (pageType == 'toofd' ? '.ofd' : pageType == 'toceb' ? '.ceb' : '.pdf')">{{
						folderName.length > 15 ? folderslname : folderName
				}}{{ pageType == "toofd" ? ".ofd" : pageType ==
		"toceb" ? ".ceb" : ".pdf"
}}</a>
				<div class="cs_button_box">
					<span>转换失败</span>
					<el-button class="agin_btn" @click="getTransfer(0, 'isReTurn')">重试</el-button>
				</div>
			</div>
		</div>
		<el-table :data="fileList" v-if="!isClickTurn && !isMergeTurn" row-key="id" max-height="323">
			<el-table-column width="435" align="left">
				<template slot="header" slot-scope="slot">
					<span>文件</span>
					<span class="tips">已添加 {{ fileList.length }} 个文件</span>
				</template>
				<template slot-scope="scope">
					<icon :type="1" :fileType="scope.row.fileTypeCase" :isTable="true"
						:fileFail="scope.row.cause || scope.row.zhError"></icon>
					<div class="fonts">
						<a :style="{
							color: scope.row.cause || scope.row.zhError ? '#8B97AF' : '#242F44'
						}" :title="scope.row.name + '.' + scope.row.fileType" class="hidea">{{ scope.row.name | ellipsis }}{{ "." +
		scope.row.fileType
}}</a>
					</div>
				</template>
			</el-table-column>
			<el-table-column width="288" align="left">
				<template slot="header" slot-scope="slot">
					<!-- <i class="size_icon"></i> -->
					<span>大小</span>
				</template>
				<template slot-scope="scope" align="left">
					<span :style="{
						color: scope.row.cause || scope.row.zhError ? '#8B97AF' : '#242F44'
					}">{{ scope.row.getfilesize }}</span>
				</template>
			</el-table-column>
			<!-- <el-table-column width="176" align="left">
        <template slot="header" slot-scope="slot">
          <span>页数</span>
        </template>
        <template slot-scope="scope" align="left">
          <span
            :style="{
              color: allzhSuccessEnd && scope.row.cause ? '#8B97AF' : '#242F44',
            }"
            >{{ scope.row.pageCount == "0" ? "--" : scope.row.pageCount }}</span
          >
        </template>
			</el-table-column>-->
			<el-table-column width="273" align="left">
				<template slot="header" slot-scope="slot">
					<!-- <i class="zt_icon"></i> -->
					<span>状态</span>
				</template>
				<template slot-scope="scope">
					<div v-if="scope.row.wait">
						<i class="wait_icon"></i>等待上传
					</div>

					<div
						v-if="scope.row.upLoadSuccess && !scope.row.isTurnIng && !scope.row.zhError && !scope.row.zhSuccess">
						<i class="success_icon"></i>
						<span>上传成功</span>
					</div>
					<div v-if="scope.row.isUpLoading && !scope.row.cause && !scope.row.wait">
						<i class="uploading_icon"></i>
						<span>
							上传中
							<span class="slh">...</span>
						</span>
					</div>
					<div v-if="scope.row.isTurnIng && !scope.row.wait">
						<i class="turn_icon"></i>
						<span>
							转换中
							<span class="slh">...</span>
						</span>
					</div>
					<div v-if="scope.row.cause && !scope.row.zhError && !scope.row.zhSuccess">
						<i class="error_icon"></i>
						<span :style="{ color: allzhSuccessEnd ? '#8B97AF' : '#242F44' }">
							上传失败
							<a title="重试" class="retry_icon"
								v-if="!allzhSuccessEnd && !scope.row.isTurnIng && !isReTurn && !allisTurnIng"
								@click="onFileAdded(scope.row, 'isReUpload')">
								<!-- <i class="el-icon-refresh-right"></i> -->
								重试
							</a>
						</span>
					</div>
					<div v-if="scope.row.zhSuccess && !scope.row.cause">
						<i class="zh_success" v-if="pageType == 'toofd'"></i>
						<i class="zh_success pdf" v-if="pageType == 'topdf' || pageType == 'ofdtopdf'"></i>
						<i class="zh_success ceb" v-if="pageType == 'toceb'"></i>
						转换成功
					</div>
					<div v-if="scope.row.zhError">
						<i class="zh_error"></i>转换失败
						<a title="重试" class="retry_icon" @click="getTransfer(scope.$index, 'isReTurn')">
							<!-- <i class="el-icon-refresh-right"></i> -->
							重试
						</a>
					</div>
				</template>
			</el-table-column>
			<el-table-column width="150">
				<template slot="header" slot-scope="slot">
					<!-- <i class="cz_icon"></i> -->
					<span>操作</span>
				</template>
				<template slot-scope="scope" v-if="(!scope.row.cause && allzhSuccessEnd) || !allzhSuccessEnd">
					<a :title="uploadSuccessList.length > 1 && scope.row.index == uploadSuccessList[0].index ? '' : '上移'"
						v-if="!allzhSuccessEnd && !allisTurnIng && uploadSuccessList.length > 1 && !scope.row.cause"
						class="up_icon" :class="{
							disable:
								allUpLoadIng ||
								(uploadSuccessList.length > 1 && scope.row.index == uploadSuccessList[0].index) ||
								scope.row.zhSuccess ||
								scope.row.zhError ||
								scope.row.cause ||
								allisTurnIng ||
								uploadSuccessList.length <= 1
						}" @click="scope.row.isUpLoading ? '' : changeUpBtn(scope.row, scope.$index)"></a>
					<a :title="uploadSuccessList.length > 1 && scope.row.index == uploadSuccessList[uploadSuccessList.length - 1].index ? '' : '下移'"
						v-if="!allzhSuccessEnd && !allisTurnIng && uploadSuccessList.length > 1 && !scope.row.cause"
						class="change_icon" :class="{
							disable:
								allUpLoadIng ||
								(uploadSuccessList.length > 1 && scope.row.index == uploadSuccessList[uploadSuccessList.length - 1].index) ||
								scope.row.zhSuccess ||
								scope.row.zhError ||
								scope.row.cause ||
								allisTurnIng ||
								uploadSuccessList.length <= 1
						}" @click="scope.row.isUpLoading ? '' : changeDownBtn(scope.row, scope.$index)"></a>
					<a title="下载" v-if="(!allUpLoadIng && !allisTurnIng && scope.row.zhSuccess) || allzhSuccessEnd"
						class="down_icon"
						:class="[allzhSuccessEnd && scope.row.zhError ? 'disable' : '', scope.row.isDowning ? 'downing' : '']"
						@click="!scope.row.zhSuccess || allisTurnIng ? '' : downdBtn(scope.row)"></a>
					<a title="预览"
						v-if="(pageType != 'toceb' && !allUpLoadIng && !allisTurnIng && scope.row.zhSuccess) || allzhSuccessEnd"
						class="open_icon" :class="{ disable: allzhSuccessEnd && scope.row.zhError }"
						@click="!scope.row.zhSuccess || allisTurnIng ? '' : readApi(scope.row.shortUrl)"></a>
				</template>
			</el-table-column>
			<el-table-column width="52">
				<template slot="header" slot-scope="slot">
					<!-- <i class="cz_icon"></i> -->
					<span></span>
				</template>
				<template slot-scope="scope" v-if="(!scope.row.cause && allzhSuccessEnd) || !allzhSuccessEnd">
					<a title="删除" v-if="!allUpLoadIng && !allisTurnIng" class="delet_icon"
						:class="{ disable: allUpLoadIng || allisTurnIng }" @click="suspendBtn(scope.row)"></a>
				</template>
			</el-table-column>
		</el-table>
		<merge-turn :isMergeTurnData="isMergeTurn" :MergeTurnData="MergeData"></merge-turn>
		<div class="table_bottom" v-if="showBottom">
			<div class="left">
				<el-popover placement="top-start" width="300" v-model="visible">
					<p style="margin-bottom: 50px">确认将列表中的全部文件删除吗？</p>
					<div style="text-align: right; margin: 0">
						<el-button type="primary" size="mini" class="mini_btn" @click="submitBtn">删除</el-button>
						<el-button size="mini" type class="mini_btn" @click="visible = false">取消</el-button>
					</div>
					<el-button slot="reference" :disabled="allUpLoadIng || allisTurnIng"
						v-if="!allzhSuccessEnd && !allZhError">清空列表</el-button>
				</el-popover>
				<div class="hb_box" :class="{
					disable: allUpLoadIng || allisTurnIng || allzhSuccessEnd || uploadSuccessList.length <= 1
				}" v-if="(pageType == 'toofd' || pageType == 'topdf' || pageType == 'ofdtopdf') && fileList.length > 1 && !allzhSuccessEnd && uploadSuccessList.length > 1">
					<el-checkbox v-model="isMerge"
						:disabled="allUpLoadIng || allisTurnIng || (allzhSuccessEnd && !isMerge) || allZhError || uploadSuccessList.length <= 1">
						合并转换为一个文档</el-checkbox>
				</div>
				<div class="hb_box"
					v-if="!allzhSuccessEnd && !allUpLoadIng && !allisTurnIng && uploadSuccessList.length != fileList.length">
					<i class="tips_icon"></i>
					<span style="color: #e02020">上传失败的文件无法进行转换</span>
				</div>
			</div>
			<div class="right">
				<uploader ref="uploader" :options="options" :autoStart="false" @file-added="onFileAdded"
					@files-submitted="onSubmitted" v-if="!allUpLoadIng && !allisTurnIng && !allzhSuccessEnd"
					class="uploader-app el-button el-button--default el-popover__reference">
					<uploader-btn :attrs="attrs" ref="uploadBtn">添加文件</uploader-btn>
				</uploader>
				<el-button class="downZip" @click="downZip" :class="{ disable: isDown }" :disabled="isDown"
					v-if="allzhSuccessEnd && downzhSuccessList.length > 1">
					<span v-if="!isDown">打包下载</span>
					<span v-else>
						<i class="downing_icon"></i>
						打包下载
					</span>
				</el-button>
				<el-button v-if="!allzhSuccessEnd" type="primary" key="autoButton"
					:disabled="allUpLoadIng || allisTurnIng || uploadSuccessList.length <= 0"
					@click="changeTurn">{{ allisTurnIng ? "转换中..." : "开始转换" }}</el-button>

				<el-button
					v-if="(!allUpLoadIng && !allisTurnIng && allzhSuccessEnd) || (allZhError && !allisTurnIng && isMerge)"
					type="primary" @click="reLoadTurn">继续转换</el-button>
			</div>
		</div>
		<!-- 合并弹框 -->
		<el-dialog title="文档命名" :visible.sync="dialogFolder" class="changephone_box merge" :close-on-click-modal="false"
			width="460px" append-to-body :show-close="false">
			<div class="content">
				<el-input ref="textFolder" type="text" placeholder="请输入文件名称" v-model="folderName" maxlength="25">
				</el-input>
				<span>{{ pageType == "toofd" ? ".ofd" : pageType == "toceb" ? ".ceb" : ".pdf" }}</span>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" type="primary" @click="submitFolder" :disabled="folderName ? false : true">确 定
				</el-button>
				<el-button @click="closedDialogFolder" size="mini">取 消</el-button>
			</div>
		</el-dialog>
		<!-- 继续转换弹框 -->
		<el-dialog title="提示" :visible.sync="dialogTips" class="changephone_box agin_box" :close-on-click-modal="false"
			width="420px" append-to-body>
			<div class="content">继续转换将清空当前列表，请您先下载保存文档。是否继续转换？</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitTurn" size="mini">确 定</el-button>
				<el-button @click="dialogTips = false" size="mini">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import Sortable from "sortablejs";
import icon from "@comm/components/document-conversion/iconImg";
import mergeTurn from "@comm/components/document-conversion/mergeTurn";
import { getfilesize } from "@comm/utils/tools";
import { packZipDownload, downloadUploadFile, fileTransfer, transferPoll, pubserviceUpload } from "@comm/api/document-conversion";
import Files from "@comm/utils/files";
import { buriedPoint, turnBuriedPoint } from "@comm/utils/buryingPoint.js";
import { getUserInfo } from "@comm/utils/auth";
export default {
	name: "domTurn",
	components: {
		icon,
		mergeTurn
	},
	props: {
		fileListData: "",
		isShowData: false,
		attrsData: "",
		pageName: "",
		allUpLoadIngData: false,
		imgtoOfdAginData: false,
		isMergeTurnData: false,
		allzhSuccessEndData: false
	},
	data() {
		return {
			newFileList: this.fileListData,
			fileList: [],
			visible: false,
			options: {
				target: "invoice-info/upload",
				chunkSize: "2048000",
				fileParameterName: "upfile",
				maxChunkRetries: 1,
				testChunks: false,
				allowDuplicateUploads: true,
				headers: {
					// Authorization: getToken(),
				},
				query() { }
			},
			attrs: {
				accept: this.attrsData
			},
			interval: "",
			isMerge: false,
			allisTurnIng: false,
			dialogFolder: false,
			folderName: "",
			dialogDownZip: false,
			downZipName: "",
			zhSuccessList: [],
			uploadSuccessList: [],
			pageType: this.pageName,
			allUpLoadIng: this.allUpLoadIngData,
			allzhSuccessEnd: this.allzhSuccessEndData,
			imgtoOfdAgin: this.imgtoOfdAginData,
			downTime: 0,
			isShow: this.isShowData,
			isDelete: false,
			progressTurn: 0,
			downzhSuccessList: [],
			createSortable: "",
			isMergeTurn: this.isMergeTurnData,
			MergeData: null,
			fileNameReg: /.*[\\\/:*?"<>|]+.*/,
			isClickTurn: false,
			isDown: false,
			addUpLad: false,
			allZhError: false,
			folderslname: "",
			isReUpload: "",
			dialogTips: false,
			transfering: false,
			transferList: [],
			transferListLng: 0,
			isReTurn: "",
			showBottom: true,
			APIPort: process.env.APIPort
		};
	},
	filters: {
		ellipsis(value) {
			if (!value) return "";
			let fileListArrayname = value;
			let fileNameSuffix1 = fileListArrayname;
			if (fileListArrayname.length > 15) {
				value = fileListArrayname.substring(0, 14) + "..." + fileNameSuffix1.substring(fileNameSuffix1.length - 1, fileNameSuffix1.length);
			}
			return value;
		}
	},
	watch: {
		attrsData(val) {
			this.attrs.accept = val;
		},
		isShowData(val) {
			this.isShow = val;
		},
		fileListData(val) {
			if (val.length > 0 && this.allUpLoadIng) {
				this.downzhSuccessList = [];
			}

			this.newFileList = val;
			this.newFileList.forEach((item) => {
				item.getfilesize = getfilesize(item.size);
			});
			if (
				this.pageType == "imgtoofd" ||
				this.pageType == "toimg" ||
				this.zhSuccessList.length > 0 ||
				(!this.isDelete && !this.addUpLad && this.uploadSuccessList.length <= 0 && this.zhSuccessList.length <= 0) ||
				(this.isDelete && !this.addUpLad) ||
				this.transfering ||
				this.isReUpload
			) {
				this.fileList = this.newFileList;

				// this.allzhSuccessEnd=false
			} else {
				this.fileList = [...this.fileList, ...this.newFileList];
			}
		},
		fileList(val) {
			if (!this.isShow) {
				return;
			}

			if (this.isMerge) {
				val.forEach((item) => {
					item.getfilesize = getfilesize(item.size);
				});
			}

			this.fileList = val;

			let uploadSuccessList = [];
			this.fileList.forEach((item, index) => {
				item.index = index;
				if (item.upLoadSuccess) {
					uploadSuccessList.push(item);
				}
			});
			this.uploadSuccessList = uploadSuccessList;
		},
		isMergeTurnData(val) {
			this.isMergeTurn = val;
			if (this.newFileList.length < 0 && this.uploadSuccessList.length < 0 && this.isMergeTurn) {
				this.allUpLoadIng = false;
				// this.isMergeTurn=false
			}
		},
		allUpLoadIngData(val) {
			this.allUpLoadIng = val;
			if (!val) {
				let uploadSuccessList = [];
				this.fileList.forEach((item, index) => {
					if (item.upLoadSuccess && !item.zhSuccess) {
						uploadSuccessList.push(item);
					} else if (item.zhSuccess) {
						this.allzhSuccessEnd = true;
						this.allisTurnIng = false;
					}
				});
				this.uploadSuccessList = uploadSuccessList;
				if (this.uploadSuccessList.length > 0) {
					this.zhSuccessList = [];
					this.MergeData = null;
					// this.addUpLad = true;
					this.allzhSuccessEnd = false;

					// this.fileList = this.newFileList
				}
				if (this.newFileList.length <= 0 && this.MergeData) {
					this.isMergeTurn = true;
					this.allzhSuccessEnd = true;
				} else {
					this.isMergeTurn = false;
				}
				if (this.newFileList.length <= 0 && this.zhSuccessList.length > 0) {
					this.allzhSuccessEnd = true;
				}
				if (this.newFileList.length <= 0 && this.zhSuccessList.length <= 0 && !this.MergeData) {
					// this.addUpLad = true;
					this.isDelete = false;
				}
				if (this.pageType == "toofd") {
					// this.$nextTick(() => {
					//   this.rowDrop();
					// });
				}
			} else {
				// if (this.createSortable) {
				//   this.createSortable.option("disabled", false); // set
				// }
				this.isMergeTurn = false;
				// if(this.zhSuccessList.length){}
			}
		},
		allzhSuccessEndData(val) {
			this.allzhSuccessEnd = val;
		},
		allzhSuccessEnd(val) {
			if (val) {
				// if (this.createSortable) {
				//   this.createSortable.option("disabled", true); // set
				// }
				this.$forceUpdate();
				let zhSuccessList = [];
				let downzhSuccessList = [];
				this.fileList.forEach((item, index) => {
					zhSuccessList.push(item);
					if (item.zhSuccess) {
						downzhSuccessList.push(item);
					}
				});
				// this.uploadSuccessList = [];
				this.downzhSuccessList = downzhSuccessList;
				this.zhSuccessList = zhSuccessList;
			}
		},
		pageName(val) {
			this.pageType = val;
			if (val == "imgtoofd") {
				this.fileList = this.newFileList;
				this.allUpLoadIng = false;
				this.allisTurnIng = false;
				this.allzhSuccessEnd = true;
				this.zhSuccessList = this.fileList;
			}
		},
		imgtoOfdAginData(val) {
			this.imgtoOfdAgin = val;
			if (val) {
				this.fileList = this.newFileList;
			}
		},
		transferList(val) {
			if (val.length > 0 && this.allisTurnIng && !this.isReTurn) {
				for (let index = 0; index < val.length; index++) {
					if (index <= 4) {
						this.getTransfer(index);
					}
				}
			}
		},
		transferListLng(val) {
			if (this.transferListLng + 5 <= this.transferList.length) {
				this.getTransfer(this.transferListLng + 4);
			}
		}
	},
	mounted() { },
	methods: {
		// merginBtn() {
		//   if (
		//     this.allUpLoadIng ||
		//     this.allisTurnIng ||
		//     this.allzhSuccessEnd ||
		//     this.uploadSuccessList.length <= 1
		//   ) {
		//     return;
		//   }
		//   this.isMerge = !this.isMerge;
		// },
		// 删除
		suspendBtn(file) {
			if (this.allUpLoadIng || this.allisTurnIng) {
				return;
			}
			// this.allzhSuccessEnd = false;
			this.addUpLad = false;
			var index = this.fileList.indexOf(file);
			this.fileList.splice(index, 1);
			if (this.fileList.length <= 1) {
				this.isMerge = false;
			}
			if (this.fileList.length <= 0) {
				this.reLoadTurnReset()
				return
			} else if (this.allzhSuccessEnd) {
				let zhSuccessList = [];
				let downzhSuccessList = [];
				this.fileList.forEach((item, index) => {
					zhSuccessList.push(item);
					if (item.zhSuccess) {
						downzhSuccessList.push(item);
					}
				});
				this.downzhSuccessList = downzhSuccessList;
				this.zhSuccessList = zhSuccessList;
			}
			let data = {
				fileList: this.fileList,
				isShow: this.isShow,
				oldFileList: this.fileList,
				isMergeTurn: this.isMergeTurn,
				MergeData: this.MergeData
			};
			this.isDelete = true;
			this.$emit("endTurn", data);
		},
		rowDrop() {
			const tbody = document.querySelector(".el-table__body-wrapper tbody");
			const selft = this;
			if (selft.fileList.length > 0) {
				this.createSortable = Sortable.create(tbody, {
					disabled: false,
					onEnd({ newIndex, oldIndex }) {
						let tData = JSON.parse(JSON.stringify(selft.fileList));
						const currRow = tData.splice(oldIndex, 1)[0];
						tData.splice(newIndex, 0, currRow);
						selft.fileList = tData;
					}
				});
			}
		},
		//上移动
		changeUpBtn(file, index) {
			// selft.fileList = [];
			// setTimeout(() => {
			//   selft.fileList = tData;
			// }, 5);
			if (index > 0 && !file.cause && !file.zhError) {
				let tData = JSON.parse(JSON.stringify(this.fileList));
				let upDate = tData[index - 1];
				tData.splice(index - 1, 1);
				tData.splice(index, 0, upDate);
				this.fileList = tData;
			}
		},
		//下移动
		changeDownBtn(file, index) {
			if (index + 1 < this.fileList.length && !file.cause && !file.zhError) {
				let tData = JSON.parse(JSON.stringify(this.fileList));
				let downDate = tData[index + 1];
				tData.splice(index + 1, 1);
				tData.splice(index, 0, downDate);
				this.fileList = tData;
			}
		},
		//打包下载
		downZip() {
			if (this.isDown) {
				return;
			}
			this.isDown = true;
			this.downTime = Date.parse(new Date());
			let sizeTotal = 0;
			this.fileList.forEach((item) => {
				sizeTotal += +item.size;
			});
			let list = [];
			this.downzhSuccessList.forEach((item) => {
				let itemArray = [];
				itemArray.push(item.fileIds);
				itemArray.push(item.name + "." + item.turnFileType);
				list.push(itemArray.toString());
			});
			packZipDownload(
				{
					list: list,
					fileZipName: this.downzhSuccessList[0].name + "." + this.downzhSuccessList[0].fileType + "...等"
				},
				false,
				true
			)
				.then((res) => {
					this.dialogDownZip = false;
					this.downloadFile(1, res, sizeTotal);
				})
				.catch((err) => {
					this.isDown = false;
					if (err.code == "ECONNABORTED" && err.message.indexOf("timeout") != -1) {
						this.$alert("网络不佳或内容过大", "提示", {
							confirmButtonText: "确定"
						});
					}
				});
		},
		// 下载
		downdBtn(file) {
			if (file.isDowning) return;
			file.isDowning = true;
			this.fileList.map((item, index) => {
				if (item.fileIds == file.fileIds) {
					this.$set(this.fileList, index, file);
				}

			});

			this.downTime = Date.parse(new Date());
			let data = {}
			data = {
				fileId: file.fileIds,
				fileName: encodeURIComponent(file.name + "." + file.turnFileType)
			}
			downloadUploadFile(data)
				.then((res) => {
					this.downloadFile(2, res, file);
				})
				.catch((err) => {
					file.isDowning = false;
					this.fileList.map((item, index) => {
						if (item.fileIds == file.fileIds) {
							this.$set(this.fileList, index, file);
						}
					});
					if (err.code == "ECONNABORTED" && err.message.indexOf("timeout") != -1) {
						this.$alert("网络不佳或内容过大", "提示", {
							confirmButtonText: "确定"
						});
					}
				});
		},
		downloadFile(type, res, file) {
			let that = this;
			let size = 0;
			if (type == 2) {
				size = file.size;
			} else {
				size = file;
			}
			Files.downloadFile(type, res, file, (type, file) => {
				this.isDown = false;
				if (type == 2) {
					file.isDowning = false;
					this.$set(this.fileList, file.index, file);
				}
				that.$forceUpdate();
				if (this.APIPort == 8001) {
					let nowTime = Date.parse(new Date());
					let time = nowTime - that.downTime;
					let dictionaryId = 0;
					let downloadType = 0;
					let downloadFileType = "";
					if (type == 1) {
						this.isDown = false;
						downloadType = 1;
						if (this.pageType == "toofd") {
							dictionaryId = 75;
							downloadFileType = 0;
						} else if (this.pageType == "ofdtopdf") {
							dictionaryId = 97;
							downloadFileType = 1;
						} else if (this.pageType == "topdf") {
							dictionaryId = 112;
							downloadFileType = 1;
						} else if (this.pageType == "toceb") {
							dictionaryId = 121;
							downloadFileType = 4;
						}
					} else {
						downloadType = 0;
						if (this.pageType == "toofd") {
							dictionaryId = 74;
							downloadFileType = 0;
						} else if (this.pageType == "ofdtopdf") {
							dictionaryId = 96;
							downloadFileType = 1;
						} else if (this.pageType == "topdf") {
							dictionaryId = 111;
							downloadFileType = 1;
						} else if (this.pageType == "toceb") {
							dictionaryId = 120;
							downloadFileType = 4;
						} else {
							if (this.fileList.length == 1 && this.fileList[0].fileType == "ofd") {
								dictionaryId = 88;
							} else {
								dictionaryId = 89;
							}
						}
					}
					setTimeout(function () {
						buriedPoint("isDown", dictionaryId, 0, downloadType, downloadFileType, time, size);
					}, 200);
				}
			});
		},
		// 预览
		readApi(shortUrl) {
			let userInfo = JSON.parse(getUserInfo())
			let nickname = encodeURIComponent(encodeURIComponent(userInfo.nickname))
			const { href } = this.$router.resolve({
				path: `/r:${shortUrl}&&${nickname}`
			});
			window.open(href, "_blank");
		},
		reLoadTurn() {
			if (this.downzhSuccessList && this.downzhSuccessList.length > 0) this.dialogTips = true;
			else this.reLoadTurnReset();
		},
		submitTurn() {
			this.reLoadTurnReset();
		},
		reLoadTurnReset() {
			this.transferListLng = 0;
			this.transferList = [];
			this.isReTurn = "";
			this.isReUpload = "";
			this.isDelete = false;
			this.transfering = false;
			this.addUpLad = false;
			this.uploadSuccessList = [];
			this.zhSuccessList = [];
			this.fileList = [];
			this.dialogTips = false;
			this.isShow = false;
			this.isAllDel = false;
			this.isMergeTurn = false;
			this.MergeData = null;
			this.allzhSuccessEnd = false;
			this.isMerge = false;
			this.isClickTurn = false;
			this.allZhError = false;
			let data = {
				fileList: [],
				isShow: false,
				oldFileList: [],
				isAllDel: false,
				isMergeTurn: false,
				MergeData: null
			};
			this.$emit("endTurn", data);
		},
		// 清空列表
		submitBtn() {
			this.transferListLng = 0;
			this.transferList = [];
			this.isReTurn = "";
			this.isReUpload = "";
			this.isDelete = false;
			this.transfering = false;
			this.dialogTips = false;
			this.fileList = [];
			this.uploadSuccessList = [];
			this.zhSuccessList = [];
			this.downzhSuccessList = [];
			this.allUpLoadIng = false;
			this.allisTurnIng = false;
			this.allzhSuccessEnd = false;
			this.allZhError = false;
			this.addUpLad = false;
			this.visible = false;
			this.isMerge = false;
			this.isMergeTurn = false;
			this.MergeData = null;
			this.isClickTurn = false;
			this.newFileList = [];
			let data = {
				fileList: this.fileList,
				isShow: false,
				oldFileList: this.fileList,
				isAllDel: true,
				isMergeTurn: this.isMergeTurn,
				MergeData: this.MergeData
			};
			this.$emit("endTurn", data);
		},
		// 上传
		onFileAdded(file, isReUpload) {
			this.isReUpload = isReUpload;
			this.isClickTurn = false;
			// this.isMerge = false;
			this.newFileList = [];

			this.fileList.forEach((item, index) => {
				item.index = index;
			});

			if (isReUpload) {
				this.isMerge = false;
				file.isReUpload = true;
				file.cause = "";
				file.isUpLoading = true;
				file.wait = false;
			}
			this.$parent.onFileAdded(file, isReUpload, this.fileList);
		},
		onSubmitted(fileList) {
			if (fileList.length <= 0) {
				return;
			}
			this.addUpLad = true;
			this.isDelete = false;
			this.allZhError = false;

			this.downzhSuccessList = [];
			// this.uploadSuccessList=[]
			if (this.pageType == "imgtoofd") {
				let data = {
					fileList: fileList
				};
				this.$emit("contupLoadImg", data);
			} else {
				// this.allUpLoadIng = true;
				this.allisTurnIng = false;
				// this.isDelete = false;
				this.allzhSuccessEnd = false;
				let data = {
					fileList: this.fileList,
					MergeData: this.MergeData,
					isMergeTurn: this.isMergeTurn,
					allzhSuccessEnd: this.allzhSuccessEnd
				};

				this.$emit("AddUpload", data);
				this.$parent.onSubmitted(fileList);
			}
		},
		closedDialogFolder() {
			this.isMerge = false
			this.dialogFolder = false
		},
		//转换
		changeTurn() {
			// if (this.turnCount >= 5) {
			//   this.$confirm("今日转换次数已达上限5次", "", {
			//     confirmButtonText: "确定",
			//     type: "warning",
			//   }).then(() => {
			//     return;
			//   });
			// }
			if (this.allUpLoadIng || this.allisTurnIng || this.allzhSuccessEnd) {
				return;
			}
			if (this.fileList.length <= 1) {
				this.isMerge = false;
			}
			this.allzhSuccessEnd = false;
			if (this.isMerge) {
				this.folderName = "";
				this.dialogFolder = true;
				this.$nextTick(() => {
					this.$refs.textFolder.focus();
				});
			} else {
				this.submitFolder();
			}
		},
		submitFolder() {
			if (this.dialogFolder) {
				if (!this.folderName.trim()) {
					this.$message.error("文件名称不能为空");
					return;
				}
				if (!this.folderName) {
					this.$message.error("请输入合并文档的名称");
					return;
				}

				if (this.fileNameReg.test(this.folderName)) {
					this.$message.error('文件名称不能包含下列任何字符：\\/:*?"<>|');
					return;
				}
			}
			if (this.isMerge) {
				this.isClickTurn = true;
			}
			// if (this.uploadSuccessList.length > 0 && this.zhSuccessList.length <= 0) {
			//   this.addUpLad = true;
			// }
			this.allisTurnIng = true;
			this.isMergeTurn = false;
			this.dialogFolder = false;
			// if (this.createSortable) {
			//   this.createSortable.option("disabled", true); // set
			// }
			this.transfering = true;

			this.$forceUpdate();
			this.allzhSuccessEnd = false;

			if (this.isMerge) {
				this.getTransfer(0);
			} else {
				this.fileList.forEach((item) => {
					this.transferList.push(item);
				});
			}
		},
		getTransfer(i, isReTurn) {
			this.isReTurn = isReTurn;
			if (this.isReTurn) {
				this.transferListLng = 0;
				this.transferList = [];
				this.transferList.push(this.fileList[i]);

				this.allzhSuccessEnd = false;
				this.allisTurnIng = true;
				this.allZhError = false;
				this.fileList[i].zhError = false;
				this.fileList[i].isTurnIng = true;
				this.fileList[i].cause = "";
			} else if (!this.isMerge && this.transferList[i].cause) {
				this.transferListLng = this.transferListLng + 1;
				if (this.transferListLng == this.transferList.length || this.isMerge) {
					this.allisTurnIng = false;
					this.allzhSuccessEnd = true;
					return;
				}
				return;
			} else {
				this.fileList[i].isTurnIng = true;
			}
			this.downTime = Date.parse(new Date());
			let fileIds = [];
			if (this.isMerge) {
				this.showBottom = false;
				let fileListArrayname = this.folderName;
				let fileNameSuffix1 = fileListArrayname;
				if (fileListArrayname.length > 15) {
					this.folderslname = fileListArrayname.substring(0, 14) + "..." + fileNameSuffix1.substring(fileNameSuffix1.length - 1, fileNameSuffix1.length);
				}
				this.uploadSuccessList.forEach((item) => {
					fileIds.push(item.fileConversionNeedDTO);
				});
				this.progressTurn = 0;
			} else {
				fileIds.push(this.fileList[i].fileConversionNeedDTO);
			}
			this.progressTurn = 0;
			let url = "";
			let data = {};
			let upLoadType = 0;
			if (this.pageType == "toofd") {
				upLoadType = 1;
			} else if (this.pageType == "ofdtopdf") {
				upLoadType = 2;
			} else if (this.pageType == "topdf") {
				upLoadType = 5;
			} else if (this.pageType == "toceb") {
				upLoadType = 4;
			}
			if (this.isMerge) {
				data = {
					fileConversionNeedDTOs: fileIds,
					fileName: this.folderName,
					transferType: this.pageType == "toofd" ? 1 : 2,
					dirType: upLoadType
				};

			} else {
				data = {
					fileConversionNeedDTO: this.fileList[i].fileConversionNeedDTO,
					transferType: this.pageType == "toofd" ? 1 : 2,
					dirType: upLoadType
				};
			}
			// }
			let that = this;
			let obj = this.fileList[i];
			//transferType 1文件转ofd   2文件转pdf
			fileTransfer(this.isMerge, data)
				.then((res) => {
					if (!res.data) {
						this.transferListLng = this.transferListLng + 1;
						obj.zhError = true;
						obj.isTurnIng = false;
						obj.cause = res.msg;
						this.$set(this.fileList, i, obj);
						if (this.transferListLng == this.transferList.length || this.isMerge || this.fileList[i].isReTurn) {
							this.showBottom = true;
							this.allisTurnIng = false;
							this.allzhSuccessEnd = true;
							// this.addUpLad = true;
							// this.isMerge = false;
							this.allZhError = true;
							return;
						}
					} else {
						obj.ticket = res.data;
						obj.pollNum=0
						this.$set(this.fileList, i, obj);
						let that = this;
						setTimeout(function () {
							that.getTransferPoll(res.data, i);
						}, 5000);
					}
				})
				.catch((res) => {
					this.transferListLng = this.transferListLng + 1;
					obj.zhError = true;
					obj.isTurnIng = false;
					obj.cause = res.msg;
					this.$set(this.fileList, i, obj);
					if (this.transferListLng == this.transferList.length || this.isMerge || this.fileList[i].isReTurn) {
						this.showBottom = true;
						this.allisTurnIng = false;
						this.allzhSuccessEnd = true;
						// this.isMerge = false;
						this.allZhError = true;
						return;
					}
				});
		},
		//轮询
		getTransferPoll(data, index) {
			let obj = this.fileList[index];
			this.fileList[index].pollNum++
			if (!this.fileList[index].interval) {
				this.fileList[index].interval = null;
			}
			let that = this;
			if(this.fileList[index].pollNum>10){
				if (this.fileList[index].interval) {
						clearInterval(this.fileList[index].interval);
						this.fileList[index].interval = null;
					}

					// that.$message.error(res.msg);
					if (!this.isMerge) {
						obj.zhError = true;
						obj.isTurnIng = false;
						obj.pollNum = 0
						this.$set(this.fileList, index, obj);
						this.transferListLng = this.transferListLng + 1;
						if (this.transferListLng == this.transferList.length || this.fileList[index].isReTurn) {
							this.allisTurnIng = false;
							this.allzhSuccessEnd = true;
							// this.allZhError=true
						}
					} else {
						this.fileList[index].pollNum = 0;
						this.showBottom = true;
						this.allisTurnIng = false;
						this.allzhSuccessEnd = true;
						// this.isMerge = false;
						this.allZhError = true;
					}
					if (this.APIPort == 8001) {
						let nowTime = Date.parse(new Date());
						let time = nowTime - this.downTime;
						let transferType = 0;
						let turnFileType = "";
						if (this.pageType == "toofd") {
							turnFileType = "ofd";
						} else if (this.pageType == "ofdtopdf") {
							turnFileType = "pdf";
						} else if (this.pageType == "topdf") {
							turnFileType = "pdf";
						} else if (this.pageType == "toceb") {
							turnFileType = "ceb";
						}
						if (this.isMerge) {
								transferType = 2;
							} else if (this.fileList.length <= 1) {
								transferType = 0;
							} else if (this.fileList.length > 1) {
								transferType = 1;
							}
						turnBuriedPoint(
							this.pageType,
							this.fileList[index].name,
							this.fileList[index].size,
							turnFileType,
							time,
							0,
							transferType,
							1,
							this.fileList[index].pageCount
						);
					}
					this.$message.error('网络异常，请重试！')
					return
			}
			transferPoll(data).then((res) => {
				if (res.data.status == 1) {
					clearInterval(this.fileList[index].interval);
					this.fileList[index].interval = null;
					this.fileList[index].interval = setInterval(function () {
						setTimeout(() => {
							that.getTransferPoll(data, index);
						}, 0);
					}, 3000);
				} else if (res.data.status == 0) {
					if (this.fileList[index].interval) {
						clearInterval(this.fileList[index].interval);
						this.fileList[index].interval = null;
					}
					sessionStorage.setItem("turnCount", res.data.count);
					this.turnCount = sessionStorage.turnCount;
					// this.uploadSuccessList = [];
					let turnFileType = "";
					if (this.pageType == "toofd") {
						turnFileType = "ofd";
					} else if (this.pageType == "ofdtopdf") {
						turnFileType = "pdf";
					} else if (this.pageType == "topdf") {
						turnFileType = "pdf";
					} else if (this.pageType == "toceb") {
						turnFileType = "ceb";
					}
					if (this.isMerge) {
						res.data.result.forEach((item) => {
							item.fileType = turnFileType;
							item.name = item.fileName;
							item.url = item.url;
							item.fileIds = item.fileId;
							item.size = item.fileSize;
							item.pageCount = item.pageCount;
							item.zhSuccess = true;
							item.isTurnIng = false;
							item.disable = true;
							item.isDowning = false;
							item.turnFileType = turnFileType;
							item.pollNum = 0
						});

						res.data.result[0].slname = this.folderslname;
						this.MergeData = res.data.result[0];
						this.fileList = res.data.result;
						this.showBottom = true;
						this.isMergeTurn = true;
						this.isClickTurn = false;
						this.getpubserviceUpload(this.MergeData, this.fileList[0].turnFileType, this.fileList[0].name, 0)

					} else {
						obj.zhSuccess = true;
						obj.isTurnIng = false;
						obj.isDowning = false;
						obj.cause = "";
						obj.zhError = false;
						obj.pollNum = 0
						this.$set(this.fileList, index, obj);
						this.fileList[index].name = res.data.result[0].fileName;
						this.fileList[index].url = res.data.result[0].url;
						this.fileList[index].fileIds = res.data.result[0].fileId;
						this.fileList[index].size = res.data.result[0].fileSize;
						this.fileList[index].pageCount = res.data.result[0].pageCount;
						this.fileList[index].fileConversionNeedDTO.url = res.data.result[0].url;
						this.getpubserviceUpload(this.fileList[index].fileConversionNeedDTO, turnFileType, this.fileList[index].name, index)

					}


				} else {
					if (this.fileList[index].interval) {
						clearInterval(this.fileList[index].interval);
						this.fileList[index].interval = null;
					}

					// that.$message.error(res.msg);
					if (!this.isMerge) {
						obj.zhError = true;
						obj.isTurnIng = false;
						obj.pollNum = 0
						this.$set(this.fileList, index, obj);
						this.transferListLng = this.transferListLng + 1;
						if (this.transferListLng == this.transferList.length || this.fileList[index].isReTurn) {
							this.allisTurnIng = false;
							this.allzhSuccessEnd = true;
							// this.allZhError=true
						}
					} else {
						this.fileList[index].pollNum = 0;
						this.showBottom = true;
						this.allisTurnIng = false;
						this.allzhSuccessEnd = true;
						// this.isMerge = false;
						this.allZhError = true;
					}
					if (this.APIPort == 8001) {
						let nowTime = Date.parse(new Date());
						let time = nowTime - this.downTime;
						let transferType = 0;
						let turnFileType = "";
						if (this.pageType == "toofd") {
							turnFileType = "ofd";
						} else if (this.pageType == "ofdtopdf") {
							turnFileType = "pdf";
						} else if (this.pageType == "topdf") {
							turnFileType = "pdf";
						} else if (this.pageType == "toceb") {
							turnFileType = "ceb";
						}
						if (this.isMerge) {
								transferType = 2;
							} else if (this.fileList.length <= 1) {
								transferType = 0;
							} else if (this.fileList.length > 1) {
								transferType = 1;
							}
						turnBuriedPoint(
							this.pageType,
							this.fileList[index].name,
							this.fileList[index].size,
							turnFileType,
							time,
							0,
							transferType,
							1,
							this.fileList[index].pageCount
						);
					}
				}
			});
			// }
		},
		getpubserviceUpload(file, turnFileType, name, index) {
			pubserviceUpload({
				fileName: name + '.' + turnFileType,
				fileUrl: file.url,
				fileType: turnFileType,
				fileSize: file.fileSize,
				fileId: file.fileId,
				zipPassword: '' //解压密码
			})
				.then((res) => {
					let data = res.data.data;
					if (data) {
						// if(this.isMerge){
						// 	this.isMerge.shortUrl=data.shortUrl
						// }
						this.fileList[index].shortUrl = data.shortUrl
						this.fileList[index].turnFileType = turnFileType
						if (this.APIPort == 8001) {
							let nowTime = Date.parse(new Date());
							let time = nowTime - this.downTime;
							let transferType = 0;
							if (this.isMerge) {
								transferType = 2;
							} else if (this.fileList.length <= 1) {
								transferType = 0;
							} else if (this.fileList.length > 1) {
								transferType = 1;
							}
							//  this.isMerge = false;
							turnBuriedPoint(
								this.pageType,
								this.fileList[index].name,
								this.fileList[index].size,
								this.fileList[index].turnFileType,
								time,
								1,
								transferType,
								1,
								this.fileList[index].pageCount
							);
						}
						if (this.fileList.length <= 1) {
							this.allisTurnIng = false;
							this.allzhSuccessEnd = true;
							this.readApi(data.shortUrl);


							return;
						} else {
							if (!this.isMerge) {
								this.transferListLng = this.transferListLng + 1;
								if (this.transferListLng == this.transferList.length || this.fileList[index].isReTurn) {
									this.allisTurnIng = false;
									this.allzhSuccessEnd = true;
									this.isMerge = false;
								}
							}
						}
						
					}
				})
				.catch((err) => {

				});
		},
	}
};
</script>
<style lang="scss">
.el-table__body {
	width: 100% !important;
}

.el-table td {
	padding: 0 !important;
	height: 55px;
}

.table_box .el-table td,
.table_box .el-table th.is-leaf {
	border: none !important;
}

.el-table thead th,
.el-table thead tr {
	background: #f5f7f9;
}

.el-table thead th {
	padding: 0 !important;
	height: 46px;
	font-size: 16px;
	color: #36425a;
	font-weight: normal;
	line-height: 22px;

	.cell span {
		font-size: 16px;
	}
}

.el-table th>.cell {
	padding-left: 4px !important;
}

.el-table::before {
	display: none;
}

.el-table__body-wrapper {
	box-sizing: border-box;
}

.el-table__body {
	table-layout: inherit;
}

.el-table--enable-row-transition .el-table__body td:first-child>.cell {
	padding-left: 30px;
}

.el-table th:first-child>.cell,
.el-table td:first-child>.cell {
	padding-left: 32px !important;

	.tips {
		font-size: 12px;
		color: #8b97af;
		line-height: 22px;
		margin-left: 12px;
	}
}

.el-table th:last-child>.cell {
	padding-right: 32px;
}

.el-table thead .el-table tr {
	padding: 0 32px;
}

.el-popover {
	padding: 20px;
}

.el-table .cell {
	font-size: 14px;
	line-height: 22px !important;
	padding: 0 !important;

	.fonts {
		display: inline-block;
		width: 92%;
		vertical-align: middle;
	}
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.isMerge_btn {
	width: auto;
	height: 40px;
	background: #FFFFFF !important;
	border-radius: 2px !important;
	border: 1px solid #14A8F0 !important;
	padding: 0 9px !important;
	line-height: 40px !important;
	color: #14A8F0 !important;

	&:hover,
	&:active {
		background: #14A8F0 !important;
		color: #fff !important;

	}
}

.retry_icon {
	font-size: 14px;
	color: #14a8f0;
	line-height: 22px;
	text-decoration: underline;
	padding-left: 23px;
	cursor: pointer;
}

.el-button:hover,
.el-button--default:focus,
.el-button:active {
	background: none;
	border: 1px solid #dcdfe6;
	color: #606266;
}

.changephone_box {
	.content {
		.el-input {
			width: 80%;
		}
	}

	&.agin_box {
		.el-dialog__body {
			padding: 0 24px 64px;
		}
	}
}

.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
	color: #c0c4cc;
}

.el-button--primary.is-disabled,
.el-button--primary.is-disabled:active,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:hover {
	color: #fff;
	background-color: #a0cfff;
	border-color: #a0cfff;
}

.el-button--primary:hover,
.el-button--primary:active,
.el-button--primary:focus {
	background-color: #14a8f0;
	border-color: #14a8f0;
	color: #fff;
}

.el-checkbox__input.is-disabled+span.el-checkbox__label {
	color: #c0c4cc !important;
}

.hidea {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	display: block;
}

.no_list {
	display: flex;
	flex-direction: column;
	align-items: center;
	font-size: 16px;
	color: #242f44;
	line-height: 22px;
	height: 323px;
	justify-content: center;

	.turn_box {
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 24px;
	}

	img {
		width: 64px;
		height: 64px;
		margin-right: 12px;
	}
}

.table_box {
	height: 100%;

	.turn_ing {
		font-size: 16px;
		color: #6d7278;
		line-height: 22px;
	}

	.uploader {
		width: auto;
		padding: 0 !important;
		border: none !important;
	}

	.downZip {
		margin-left: 28px;

		&:hover {
			cursor: pointer;
			color: #15b2ff;
		}

		&:focus,
		&:active {
			color: #1299d9;
		}

		&.disable {
			color: #c0c4cc;
			position: relative;
		}
	}

	.uploader-btn {
		margin: 0;
		padding: 8px 19px;
		line-height: 22px;
		border: 1px solid #d7d9de;
		color: #36425a;
		border-radius: 2px;
		font-weight: normal;

		&:hover {
			background: none !important;
			border: 1px solid #15b2ff !important;
			color: #15b2ff !important;
		}
	}

	.el-table {
		height: 323px;
		overflow-y: auto;
	}

	.table_bottom {
		height: 88px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 32px;
		border-top: 1px #f3f4f5 solid;

		.left {
			.hb_box {
				display: inline-block;
				font-size: 14px;
				color: #4f5d79;
				line-height: 22px;
				margin-left: 24px;

				&.disable {
					color: #c0c4cc;
				}
			}
		}
	}
}

.el-table td>span {
	display: inline-block;
	width: 24px;
}

.el-table td div.fonts {
	display: inline-block;

	a {
		font-size: 14px;
		color: #242f44;
		line-height: 22px;

		&:hover {
			color: #242f44;
			text-decoration: none;
		}
	}
}

.el-table td div.el-progress {
	width: 70%;
}

.fail_box {
	text-align: left;
	margin-top: 66px;

	a {
		padding-left: 12px;
		font-size: 16px;
		color: #242f44;
		line-height: 22px;
	}
}

.cs_button_box {
	text-align: left;
	margin-top: 32px;

	span {
		font-size: 14px;
		color: #36425a;
		line-height: 22px;
		width: 64px;
		display: inline-block;
		text-align: center;
		margin-right: 28px;
	}
}
</style>



// WEBPACK FOOTER //
// src/comm/components/document-conversion/domTurn/index.vue